export const CATEGORIES = [
  "Software Engineering",
  "Business",
  "Education",
  "Artificial Intelligence",
  "Machine Learning",
];

export const FALLBACK_THUMB =
  "https://img.freepik.com/premium-photo/flat-lay-black-gray-tech-gadgets-black-background_14117-686849.jpg";

export const FALLBACK_AVATAR =
  "https://i.pinimg.com/originals/39/a4/71/39a47159059f38a954d77e5dcae6f0db.jpg";

export const GEMINI_URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash-latest:generateContent?key=${process.env.REACT_APP_GEMINI_KEY}`;

export const uploadUrl = (file) => `${process.env.REACT_APP_ASSETS_URL}/uploads/${file}`;

export const fallbackTo = (src) => (event) => {
  event.currentTarget.onerror = null;
  event.currentTarget.src = src;
};

export const stripHtml = (html = "") =>
  html
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();

export const readTime = (html = "") =>
  `${Math.max(1, Math.ceil(stripHtml(html).split(" ").length / 220))} min read`;

export const authHeaders = (token) => ({
  withCredentials: true,
  headers: { Authorization: `Bearer ${token}` },
});
